// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__dsZZy","modal":"Modal_modal__wRdwV","slide-down":"Modal_slide-down__CtIHy","color-w":"Modal_color-w__8bCpy"};